var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c(
        "div",
        {
          staticClass: "landing-alert",
          style: {
            backgroundColor: _vm.computedBackgroundColor,
            ..._vm.customStyles,
          },
        },
        [
          _vm.icon
            ? _c("div", { staticClass: "landing-alert__icon" }, [
                _c("img", { attrs: { src: _vm.icon, alt: "" } }),
              ])
            : _vm._e(),
          _c("div", {
            staticClass: "landing-alert__text",
            domProps: { innerHTML: _vm._s(_vm.text) },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }